import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

/**
 * Hook to fetch Advent Pass eligibility criteria
 * Available to all users (authenticated and unauthenticated)
 * Returns the criteria to determine which events are eligible for the discount
 */
export const useAdventPassEligibility = () => {
  return useQuery({
    queryKey: ['advent-pass-eligibility'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('partner_codes')
        .select('code, valid_from, valid_until, discount_percentage, applies_to_tags, is_active')
        .eq('code', 'ADVENTPASS')
        .eq('is_active', true)
        .maybeSingle();
      
      if (error || !data) {
        return null;
      }
      
      return {
        validFrom: data.valid_from ? new Date(data.valid_from) : null,
        validUntil: data.valid_until ? new Date(data.valid_until) : null,
        discountPercentage: data.discount_percentage || 0,
        appliesToTags: data.applies_to_tags || [],
      };
    },
  });
};
